module.exports = __webpack_public_path__ + "img/holzdeck02.aaa68e24.webp";